var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcAttendTitle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-attend-title_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F3F4F8",
  d: "M15 30c8.284 0 15-6.716 15-15S23.284 0 15 0 0 6.716 0 15s6.716 15 15 15"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B6BAC0",
  d: "M21.55 17.55H8.45a2.18 2.18 0 0 0-2.188 2.188c0 1.213.975 2.188 2.187 2.188h13.113a2.18 2.18 0 0 0 2.187-2.188 2.18 2.18 0 0 0-2.187-2.187z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#84868A",
  d: "M12.087 15.363a3.637 3.637 0 1 0 0-7.275 3.637 3.637 0 0 0 0 7.275M19.375 15.363a2.188 2.188 0 1 0 0-4.375 2.188 2.188 0 0 0 0 4.375"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-attend-title_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})))));
export default SvgIcAttendTitle;